module.exports = __webpack_public_path__ + "static/img/til122.b744ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til122.png
// module id = ewb5
// module chunks = 1